import React from 'react';
import { Box } from '@mui/material';

interface FormContainerProps {
  children: React.ReactNode;
  layout?: 'grid' | 'column';
}

export const FormContainer: React.FC<FormContainerProps> = ({
  children,
  layout = 'grid'
}) => {
  return (
    <Box
      sx={{
        display: layout === 'grid' ? 'grid' : 'flex',
        gridTemplateColumns:
          layout === 'grid' ? 'repeat(auto-fill, minmax(250px, 1fr))' : 'none', // Only apply grid styles if layout is 'grid'
        gap: '0.8rem',
        flex: 1,
        ...(layout === 'column' && { flexDirection: 'column' }),
        height: '100%'
      }}
    >
      {children}
    </Box>
  );
};
